import { breakpoints } from 'style'
import styled from 'styled-components'

export const AccordionItemContainer = styled.div`
  border-bottom: 1px solid #f2f2f2;

  .custom-accordion-toggler {
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 45px;
    padding: 5px 0px;
  }
  @media (max-width: ${breakpoints.sm}px) {
    .custom-accordion-toggler {
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
